import { useEffect, useRef, useState } from 'react'

export default function StatCounter({ target, suffix = '', className, style }) {
  const ref = useRef(null)
  const [display, setDisplay] = useState(`${target}${suffix}`)
  const [popped, setPopped] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          setPopped(true)
          const duration = 1400
          const fps = 60
          const steps = duration / (1000 / fps)
          const inc = target / steps
          let current = 0
          const timer = window.setInterval(() => {
            current += inc
            if (current >= target) {
              current = target
              window.clearInterval(timer)
            }
            setDisplay(Number.isInteger(target) ? `${Math.floor(current)}${suffix}` : `${current.toFixed(1)}${suffix}`)
          }, 1000 / fps)
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0.6 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [target, suffix])

  return (
    <p ref={ref} className={`${className} stat-counter${popped ? ' counter-popped' : ''}`} style={style}>
      {display}
    </p>
  )
}
